export const enterServicePanel = (socket) => {
  if (!socket) return;
  // console.log('enterServicePanel'); 
  socket.emit("enterServicePanel");
};
